export function signupToPartnerStack() {
  try {
    const growsumo = window?.growsumo;

    growsumo.data.name = localStorage.getItem("user_name");
    growsumo.data.email = localStorage.getItem("user_email");
    growsumo.data.customer_key = localStorage.getItem("shop_id");
    growsumo.data.provider_key = localStorage.getItem("subscription_customer_uid");

    growsumo.createSignup();
  } catch (err) {
    console.error(err);
  }
}
